import { LeftArrowIcon, RightArrowIcon } from 'Assets/icons/v2';
import CommonButton from 'components/Common/CommonButton';
import StepProgressBar from 'components/Common/StepProgressBar';
import Step1 from 'components/shared/OnboardV2/Step1';
import Step2 from 'components/shared/OnboardV2/Step2';
import Step3 from 'components/shared/OnboardV2/Step3';
import Step4 from 'components/shared/OnboardV2/Step4';
import React, { useEffect, useState } from 'react';
import { useGetProfileQuery } from 'store/services/auth';
import { Formik, Form } from 'formik';
import { useGetMySchoolDataQuery, useGetPoliciesDataQuery, useUpdateOnboardMutation } from 'store/services/V2/profile';
import { useDispatch, useSelector } from 'react-redux';
import { updateOnboardStep } from 'store/slices/authSlice';
import LoadingOverlay from 'components/shared/LoadingOverlay';
import { useNavigate } from 'react-router-dom';
import Step from 'components/shared/OnboardV2/Step';
import OnboardHeader from 'components/shared/OnboardV2/OnboardHeader';
import onboardSchema from './onboard.schema';
import { isEmpty } from 'lodash';
import { Col, Row } from 'react-bootstrap';

function Onboard() {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { data: therapistDetails, isLoading } = useGetProfileQuery();
  const { data: schoolDetails, isLoading: schoolDetailsLoading, isFetching: schoolDetailsFetching } = useGetMySchoolDataQuery();
  const [updateOnboard, { data: onboardData, isLoading: onboardLoading, isFetching: onboardFetching }] = useUpdateOnboardMutation()
  const { data: PolicyData = [], isLoading: policyLoading } = useGetPoliciesDataQuery();

  const [step, setStep] = useState(userInfo.on_board_step);
  const totalSteps = 4;

  useEffect(() => {
    if (!userInfo) return;

    if (userInfo.is_on_board_complete) {
      navigate('/');
      return;
    }
  }, [userInfo, navigate]);



  const initialValues = {
    firstname: therapistDetails?.firstname || "",
    lastname: therapistDetails?.lastname || "",
    email: therapistDetails?.email || "",
    phone: Number(therapistDetails?.phone) || "",
    address1: therapistDetails?.therapist_detail?.address1 || "",
    address2: therapistDetails?.therapist_detail?.address2 || "",
    city: therapistDetails?.therapist_detail?.city || "",
    postal_code: therapistDetails?.therapist_detail?.postal_code || "",
    assign_school: schoolDetails,
    policies: therapistDetails?.therapistPolicies,
    documents: therapistDetails?.therapistDocuments,
    email_signature: therapistDetails?.therapist_detail?.email_signature,
    signature_img: therapistDetails?.therapist_detail?.signature_img,
    profile_picture: therapistDetails?.therapist_detail?.profile_picture,
    emergency_firstname: therapistDetails?.therapist_detail?.emergency_firstname || "",
    emergency_lastname: therapistDetails?.therapist_detail?.emergency_lastname || "",
    emergency_email: therapistDetails?.therapist_detail?.emergency_email || "",
    emergency_phone: therapistDetails?.therapist_detail?.emergency_phone || "",
    emergency_relationship: therapistDetails?.therapist_detail?.emergency_relationship || ""
  };

  const handleNext = () => {
    if (step < totalSteps) setStep(step + 1);
  };

  const handleBack = (formik) => {
    if (step > 1) {
      // Remove errors for the current step
      const nextErrors = { ...formik.errors };
      if (step === 3) {
        delete nextErrors.documents;
      }
      if (step === 4) {
        delete nextErrors.signature_img;
        delete nextErrors.email_signature;
      }
      formik.setErrors(nextErrors);

      setStep(step - 1);
    }
  };


  const getPayloadByStep = (step, values) => {
    switch (step) {
      case 1:
        return {
          firstname: values?.firstname,
          lastname: values?.lastname,
          // email: values?.email,
          phone: values?.phone?.toString(),
          address1: values?.address1,
          address2: values?.address2,
          city: values?.city,
          postal_code: values?.postal_code,
          emergency_firstname: values?.emergency_firstname,
          emergency_lastname: values?.emergency_lastname,
          emergency_email: values?.emergency_email,
          emergency_phone: values?.emergency_phone,
          emergency_relationship: values?.emergency_relationship
        };

      case 2:
        return {
          policies: values?.policies
        }

      case 3:
        return {
          policy_check: values?.documents?.policy_check || "",
          business_license: values?.documents?.business_license || "",
          college_registration: values?.documents?.college_registration || "",
          professional_liabilities_insurance: values?.documents?.professional_liabilities_insurance || "",
          professional_liabilities_insurances: values?.documents?.professional_liabilities_insurances || []
        }
      case 4:
        return {
          email_signature: values?.email_signature || "",
          profile_picture: values?.profile_picture || "",
          signature_img: values?.signature_img || ""
        }

      default:
        return {};
    }
  };

  const handleSubmit = async (values) => {
    if (step === 0) {
      setStep((prev) => prev + 1)
    }
    else {
      try {
        const payload = getPayloadByStep(step, values);
        const nextStepId = step;

        const resp = await updateOnboard({
          data: payload,
          id: nextStepId,
        });

        if (resp?.data?.data) {
          const updatedStep = Number(resp.data.data.step);
          const isComplete = resp.data.data.is_on_board_complete;

          dispatch(updateOnboardStep({
            on_board_step: updatedStep + 1,
            is_on_board_complete: isComplete,
          }));

          if (isComplete) {
            navigate('/');
          } else {
            setStep(updatedStep + 1); // sync UI with backend
          }
        }
      } catch (error) {
        console.error("Onboarding submit failed:", error);
      }
    }

  };


  const stepsData = [
    { title: "Review & Confirm Your Information" },
    { title: "Review & Agree to Khan’s Policies" },
    { title: "Add Documents" },
    { title: "Add Signature & Profile Image" },
  ];

  if (isLoading) return <LoadingOverlay />
  return (
    <>
      <OnboardHeader />
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={onboardSchema(step, PolicyData?.length)}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue, handleSubmit, isValid, errors, setErrors, touched, submitCount }) => {

          const isPolicyAccepted =
            PolicyData?.length > 0 &&
            PolicyData.every((policy) =>
              values?.policies?.some(
                (p) => p.policy_id === policy.id && p.is_accepted
              )
            );

          console.log("values", values)

          return (
            <Form onSubmit={handleSubmit}>
              <div className="d-flex flex-column align-items-center min-vh-100" style={{ background: "#93278F0F" }}>
                <div className="col-lg-7 col-sm-9 col-12 px-3 pb-3 bg-white min-vh-100">
                  <StepProgressBar totalSteps={totalSteps} currentStep={step} />

                  <span className='profile-title-main'>PROFILE SETUP</span>
                  {
                    step === 0 ? <h2 className='onboard-welcome'>Welcome!</h2> : <h3 className='step-title'>
                      <strong>Step {step}:</strong> {stepsData[step - 1]?.title}
                    </h3>
                  }

                  {
                    step === 0 && <Step />
                  }
                  {step === 1 && (
                    <Step1 Last Name
                      data={therapistDetails}
                      values={values}
                      setFieldValue={setFieldValue}
                    />
                  )}

                  {step === 2 && <Step2 setFieldValue={setFieldValue} values={values} data={PolicyData} isLoading={policyLoading} />}
                  {step === 3 && <Step3 setFieldValue={setFieldValue} values={values} />}
                  {step === 4 && <Step4 setFieldValue={setFieldValue} values={values} />}

                  <div style={{ marginTop: "112px" }} className={`d-flex  pe-lg-5 ${step === 0 ? 'justify-content-end' : 'justify-content-between'} `}>
                    {
                      step > 0 &&
                      <CommonButton
                        text={step === 1 ? 'Cancel' : 'Back'}
                        onClick={() => handleBack({ errors, setErrors })}
                        className="button-outlined"
                        icon={step > 1 && <LeftArrowIcon />}
                        iconPosition='left'
                        type="button"
                      />
                    }

                    {
                      (step !== 2 || isPolicyAccepted) && (
                        <CommonButton
                          text={step === totalSteps ? 'Done' : 'Next'}
                          className="button-filled"
                          icon={step !== totalSteps && <RightArrowIcon />}
                          iconPosition='right'
                          type="submit"
                          loading={onboardLoading}
                          disabled={!isValid}
                        />
                      )
                    }

                  </div>
                </div>
              </div>
              {/* {(!isEmpty(errors) && submitCount > 0) && (
              <Row className="mt-4">
                <Col lg="12">
                  <span className="error">{genericFormErrorMsg}</span>
                </Col>
              </Row>
            )} */}
            </Form>
          )
        }}

      </Formik>

    </>

  );
}

export default Onboard;
